import { RegisterBusinessView } from '@pages/register-business/register-business-routes.names';

export const CreateBusiness = 'create-business';

export const CreateBusinessView = `${RegisterBusinessView}/${CreateBusiness}`;
